import React, { HTMLProps, useState } from 'react';

type ImgProps = HTMLProps<HTMLImageElement> & {
	/**
	 * Optional fallback to render in place of a missing image
	 * @default null
	 */
	fallback?: JSX.Element | null;
};

export function Img(props: ImgProps): JSX.Element | null {
	const { fallback = null, alt } = props;
	const [isBroken, setIsBroken] = useState(false);

	function handleError(): void {
		setIsBroken(true);
	}

	if (isBroken) {
		return fallback;
	}

	return <img onError={handleError} alt={alt} {...props} />;
}
